import { Link } from "react-router"
import { Icon } from "#app/components/ui/icon"

type BreadcrumbItem = {
	label: string
	href?: string
}

export function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
	return (
		<nav aria-label="Breadcrumb">
			<ol className="flex flex-wrap items-center gap-1.5 text-sm text-muted-foreground">
				{items.map((item, index) => {
					const isLast = index === items.length - 1
					return (
						<li key={index} className="flex items-center gap-1.5">
							{index > 0 && (
								<Icon
									name="chevron-right"
									className="h-3.5 w-3.5 flex-shrink-0"
								/>
							)}
							{isLast || !item.href ? (
								<span aria-current={isLast ? "page" : undefined}>
									{item.label}
								</span>
							) : (
								<Link
									to={item.href}
									className="transition-colors hover:text-foreground"
								>
									{item.label}
								</Link>
							)}
						</li>
					)
				})}
			</ol>
		</nav>
	)
}
